import {fetchBody} from "../../config"
import { toLogout, cleanFetch } from "../apiTools";
import { getToken } from "../../component/Login/Auth";
import { URL_UMPIRE_ADD, URL_UMPIRE_GET_LIST, URL_UMPIRE_GET_DETAIL, URL_UMPIRE_EDIT, URL_UMPIRE_CHECK_NAME } from "../../setup/config_mystat";

export function api_getUmpireList ({mReqUmpireList, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqUmpireList, token}), 
      url: URL_UMPIRE_GET_LIST, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_addUmpire ({isAdd=true, mRespUmpire, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    console.log(mRespUmpire)
    cleanFetch({
      body: fetchBody({body: mRespUmpire, token}), 
      url: isAdd?URL_UMPIRE_ADD:URL_UMPIRE_EDIT, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_getUmpireDetail ({mReqUmpireDetail, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqUmpireDetail, token}), 
      url: URL_UMPIRE_GET_DETAIL, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_checkUmpireName ({mRespUmpire, success, failure}){
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mRespUmpire, token}), 
      url: URL_UMPIRE_CHECK_NAME, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}